<script lang="ts">
  import { onMount } from "svelte"
  import type { ProjectTableItem } from "@kontextwerk/control-web-client"
  import SessionsSection from "@kontextwerk/control-web-frame/shared/modules/sessions-section"
  import { visibleOrganizationProjects } from "@kontextwerk/control-web-frame/shared/logic/organization-workspace"
  import type { OrgaViewFrameContext } from "../../../../context"
  import type { PageContext } from "../../navigation"
  import { fetchOrganizationProjectTable } from "../../../../../../api/kehrblatt/projects"

  const { viewFrameContext: _viewFrameContext, pageContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
    pageContext: PageContext
  }>()

  const canAnnotateSessions = $derived(
    pageContext.permissions.allows("core.werk_sessions", "manage", { scope: "all" }),
  )

  // Internal assist projects are platform-owned; organization contexts never list them.
  const hideInternalAssistProjects = true
  let projects = $state<ProjectTableItem[]>([])

  const visibleProjects = $derived(
    visibleOrganizationProjects(projects, !hideInternalAssistProjects),
  )

  onMount(() => {
    const organizationId = pageContext.organization?.id

    if (!organizationId) return

    void fetchOrganizationProjectTable(organizationId)
      .then((items) => (projects = items))
      .catch((err) => console.error("kehrblatt_sessions_project_options_load_failed", err))
  })
</script>

<SessionsSection
  title="Sessions"
  organizationId={pageContext.organization?.id}
  organizations={pageContext.organization ? [pageContext.organization] : []}
  projects={visibleProjects}
  enableProjectFilter={true}
  allowSessionAnnotations={canAnnotateSessions}
/>
